import React, { useCallback, useEffect, useRef, useState } from 'react';
import style from '../../../../../common/Fields/SwissInput/SwissInput.scss';
import ValidationIcon from 'js/components/common/Fields/Icons/ValidationIcon';
import { ErrorMessage } from 'js/components/common/ErrorMessage';

export const CashierFieldAmount = ({
                                       type,
                                       currency,
                                       name,
                                       defaultSuggestion,
                                       cashierAmountValue,
                                       error
                                   }) => {
    const start = `${currency} `;
    const defaultState = `${currency} 0`;
    const [defaultInputState, setDefaultInputState] = useState(false);
    const inputRef = useRef(null);
    const [defaultSuggestionValue, setSuggestionValue] = useState(`${currency} ${defaultSuggestion}`);
    const [touched, setTouch] = useState(true);

    const onBlur = useCallback(() => setTouch(true), []);

    const onInvalidClick = useCallback(() => {
        setTouch(false);
        if (inputRef.current.value === defaultState) {
            setDefaultCursorPosition(true);
        } else {
            setDefaultCursorPosition(false);
        }
    }, [defaultState]);

    const onKeyPress = useCallback((e) => {
        if (e.target.value.startsWith(start)) {
            if (defaultSuggestionValue === defaultState) {
                if (e.charCode > 48 && e.charCode < 58) {
                    e.target.value = e.target.value.slice(0, e.target.value.length - 1);
                } else {
                    e.preventDefault();
                }
            }
        }
    }, [defaultState, defaultSuggestionValue, start]);

    const setDefaultCursorPosition = (isDefault) => {
        const positionCursor = isDefault ? inputRef.current.value.length - 1 : inputRef.current.value.length;
        setDefaultInputState(isDefault);
        inputRef.current.focus();
        inputRef.current.setSelectionRange(positionCursor, positionCursor);
    };

    const onKeyUp = useCallback((e) => {
        const regExp = new RegExp(/[^0-9A-Z ]/g);
        const onlyDigit = e.target.value.slice(4, e.target.value.length);

        setTouch(false);

        if (e.target.value === start) {
            e.target.value = e.target.value + 0;
            setDefaultCursorPosition(true);
        }

        if (!String(e.target.value)?.startsWith(start)) {
            if (e.target.value === start) {
                e.target.value = start + 0;
                e.preventDefault();
            }
        }

        if (e.target.value.length < defaultState.length) {
            e.target.value = defaultSuggestionValue;
            e.preventDefault();
            setDefaultCursorPosition(true);
        }

        if (regExp.test(onlyDigit)) {
            e.target.value = e.target.value.replace(regExp, '');
        }

        if (e.target.value === defaultState) {
            setDefaultInputState(true);
        } else {
            setDefaultInputState(false);
        }
    }, [defaultState, defaultSuggestionValue, start]);

    const setPosition = useCallback((e) => {
        if (e.target.value === defaultState) {
            setDefaultCursorPosition(true);
        } else {
            setDefaultCursorPosition(false);
        }
    }, [defaultState]);

    const onKeyDown = useCallback((e) => setSuggestionValue(e.target.value), []);

    useEffect(() => {
        if (cashierAmountValue) {
            inputRef.current.value = `${currency} ${cashierAmountValue}`;
        }
    }, [cashierAmountValue, currency]);

    return (
        <div className={`${style.cashierAmount} ${error && touched && style.errorFieldContainer}`}>
            <fieldset onBlur={onBlur}>
                <input type={type}
                       ref={inputRef}
                       name={name}
                       className={defaultInputState ? style.defaultColorInput : style.commonColorInput}
                       defaultValue={`${currency} ${defaultSuggestion}`}
                       onKeyUp={onKeyUp}
                       onKeyDown={onKeyDown}
                       onClick={setPosition}
                       onKeyPress={onKeyPress}
                       onPaste={e => e.preventDefault(e)}

                />
                {error && touched && (
                    <ValidationIcon
                        className={style.icon}
                        isValid={false}
                        animate={true}
                        onClick={onInvalidClick}
                    />
                )}
            </fieldset>
            {error && touched && (
                <ErrorMessage
                    error={error}
                    animate={true}
                    classNames={{ error: style.cashierAmountError }}
                />
            )}
        </div>);
};
